import { AfterViewChecked, AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { DeployParams } from 'src/app/deployParams';
import { PlatformHeadrId, SiteViewConfiguration } from 'src/app/models/enums';
import { EventVM } from 'src/app/models/event/event';
import { EventsService } from 'src/app/services/events.service';
import { environment } from 'src/environments/environment';
import { LocaleHelper } from 'src/locale/LocaleHelper';
declare var SIR: any;
declare var $: any;

@Component({
  selector: 'app-head-to-head-widget',
  templateUrl: './head-to-head-widget.component.html',
  styleUrls: ['./head-to-head-widget.component.less']
})

export class HeadToHeadWidgetComponent implements OnInit, OnDestroy, AfterViewInit {
  private language: string;
  private _betRadarEventId: number;
  private widgetLanguage: string;
  private type: string;
  clientId = '92628c1eaee83871af5e17444ec08c99';

  // @Input()
  // betRadarEventId: number;

  @Input('betRadarEventId')
  set betRadarEventId(value: number) {
    if (this._betRadarEventId !== undefined) {
      this._betRadarEventId = value;
      this.setMatchIdOnWidget();
    } else {
      this._betRadarEventId = value;
    }
  }

  constructor(private eventsService: EventsService) {

  }
  ngAfterViewInit() {
    // setTimeout(() => {
    //   // console.log('kreno');
    //   const interval = setInterval(() => { this.setWidget(interval); }, 300);
    // }, 500);
  }


  ngOnInit(): void {

    // this.widgetLanguage = LocaleHelper.languageForBetradar[this.language];

    // // tslint:disable:no-string-literal
    // if (!window['SIR']) {
    //   // console.log('widget initialized');
    //   ((a, b, c, d, e, f, g, h, i) => {
    //     // tslint:disable-next-line:no-unused-expression
    //     a[e] || (i = a[e] = () => { (a[e].q = a[e].q || []).push(arguments); },
    //       i.l = 1 * (Number)(new Date()),
    //       i.o = f,
    //       g = b.createElement(c),
    //       h = b.getElementsByTagName(c)[0],
    //       g.async = 1,
    //       g.src = d,
    //       g.setAttribute('n', e),
    //       h.parentNode.insertBefore(g, h)
    //     );
    //   })(window, document, 'script', 'https://widgets.sir.sportradar.com/' + this.clientId + '/widgetloader', 'SIR', {
    //     theme: false, // using custom theme
    //     language: this.widgetLanguage
    //   });

    // }

    // setTimeout(() => {
    //   console.log(this.betRadarEventId);
    //   // SIR('addWidget', '#sr-widget', 'headToHead.standalone', { matchId: this.betRadarEventId });
    //   SIR('addWidget', '.sr-widget', 'headToHead.standalone', {
    //     // layout: 'inline',
    //     // components: ['headtohead', 'form', 'teamstats', 'lastmatches'],
    //     components: ['headtohead', 'form'],
    //     width: 285,
    //     matchId: this.betRadarEventId
    //   });
    // }, 100);

    this.setMatchIdOnWidget();
  }

  // setWidget(interval) {
  //   if (document.querySelector('.sr-widget')) {

  //     this.setMatchIdOnWidget();

  //     if (document.querySelector('.sr-widget .srm-fullyloaded')) {
  //       clearInterval(interval);
  //     }
  //   }
  // }


  setMatchIdOnWidget() {
    // console.log(this._betRadarEventId);
    this.type = 'standalone';
    // this.type = 'button';
    SIR('addWidget', '.sr-widget', 'headToHead.' + this.type, {
      // layout: 'inline',
      // components: ['headtohead', 'form', 'teamstats', 'lastmatches'],
      components: ['headtohead', 'form'],
      width: 285,
      matchId: this._betRadarEventId
    });

    setTimeout(() => {
      // console.log('test');
      const interval = setInterval(() => { this.setDialogPosition(interval); }, 100);
    }, 200);


  }

  expandH2widget(interval1) {
    if (!document.querySelector('.sr-hth-button__button')) { return; }
    clearInterval(interval1);
    $('.sr-hth-button__button').click();
    // $('.srm-fullyloaded').css('opacity', 0);
    // $('.sr-hth-button__button').css('width', 0);
    // $('.sr-hth-button__label').css('width', 0);
    // $('.sr-hth-button__close').hide();
  }

  setDialogPosition(interval) {
    // console.log('sss');
    // console.log(!document.querySelector('.sr-widget .srm-fullyloaded .sr-hth-team-form'));
    if (this.type === 'standalone') {
      if (!document.querySelector('.sr-widget .srm-fullyloaded .sr-hth')) { return; }
    } else {
      if (!document.querySelector('.sr-widget')) { return; }
      clearInterval(interval);
      const interval1 = setInterval(() => { this.expandH2widget(interval1); }, 100);
      return;
    }
    if (document.getElementById('headToHeadWrap') === null) { return; }
    const headToHeadWrap = document.getElementById('headToHeadWrap');

    // let scrollTop = environment.localDeploy ? 0 : window.parent.scrollY;
    let scrollTop = 0;
    // const scrollTop = environment.localDeploy ? 0 : window.parent.document.getElementById('container').scrollTop;
    const windowHeight = window.parent.innerHeight;
    const documentHeight = document.body.clientHeight;

    // set max height on dialog
    if (windowHeight < documentHeight) {
      headToHeadWrap.style.maxHeight = windowHeight - 30 + 'px';
    } else {
      headToHeadWrap.style.maxHeight = documentHeight - 30 + 'px';
    }

    // set scroll not to be over footer
    if (windowHeight + scrollTop > documentHeight) {
      window.parent.scroll(0, documentHeight - windowHeight);
      scrollTop = documentHeight - windowHeight;

      if (scrollTop < 0) {
        scrollTop = 0;
      }
    }

    setTimeout(() => {
      // position dialog
      if (scrollTop + windowHeight - 30 < documentHeight) {
        const move = scrollTop + (windowHeight - headToHeadWrap.offsetHeight) / 2;
        // console.log(move);
        headToHeadWrap.style.transform = 'translate(0px, ' + move + 'px)';
      } else {
        const move = scrollTop + (documentHeight - headToHeadWrap.offsetHeight) / 2;
        // console.log(move);
        headToHeadWrap.style.transform = 'translate(0px, ' + move + 'px)';
        // const move = documentHeight - windowHeight;
        // headToHeadWrap.style.transform = 'translate(0px, 15px)';
      }

      setTimeout(() => {
        // console.log('ussoo');
        headToHeadWrap.style.opacity = '1';
        // headToHeadWrap.style.transition = 'none';

        // this.disableParentScroll();
      }, 100);
    }, 400);


    clearInterval(interval);
  }

  closeWidget() {
    this.eventsService.openCloseHeadToHeadWidget();
  }

  disableParentScroll() {
    window.parent.document.documentElement.style.overflow = 'hidden';
  }

  ngOnDestroy(): void {
   // setTimeout(() => {
      // window['SIR']('removeWidget', '.sr-widget');
      SIR('removeWidget', document.querySelector('.sr-widget'));
      setTimeout(() => {
        SIR('check');
      }, 500);
   // },100);
  }


}
